// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */
const DescriptionsItem = ({
  children
}) => children;
export default DescriptionsItem;